import { NgModule } from "@angular/core";

import { FooterComponent } from "./footer.component";

@NgModule({
  imports: [],
  exports: [FooterComponent],
  declarations: [FooterComponent],
  providers: [],
})
export class FooterModule {}
